import { useMeeting } from "@videosdk.live/react-sdk";
import React, { useCallback, useState } from "react";
import {
  StartVideoMeeting,
  EndVideoMeeting,
} from "../../common/game/GameControl";
import { useDispatch, useSelector } from "react-redux";
import { setCameraStatus } from "../../slice/cameraStatusSlice";

const StartVideo = () => {
  const user = useSelector((state) => state.auth.user);
  const gameState = useSelector((state) => state.gameState);
  const isMeetingJoined = useSelector((state) => state.auth.isMeetingJoined);
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);

  const meetingAPI = useMeeting({});

  const startVideo = useCallback(async () => {
    if (!meetingAPI?.join) {
      console.warn("[StartVideo] Meeting API not available yet");
      return;
    }
    setLoading(true);
    try {
      StartVideoMeeting(user.Id, gameState.GameCode, () => {});
      await meetingAPI.join();
      dispatch(setCameraStatus(true));
    } catch (err) {
      console.error("[StartVideo] Failed to join meeting:", err);
    } finally {
      setLoading(false);
    }
  }, [dispatch, meetingAPI, user.Id, gameState.GameCode]);

  const endVideo = useCallback(() => {
    if (!meetingAPI) return;
    setLoading(true);
    if (gameState.GameCreatorId === user.Id) {
      EndVideoMeeting(user.Id, gameState.GameCode, async () => {
        meetingAPI.end();
      });
      setTimeout(() => {
        setLoading(false);
        dispatch(setCameraStatus(false));
      }, 6000);
    } else {
      meetingAPI.leave();
      setLoading(false);
    }
  }, [dispatch, gameState.GameCode, gameState.GameCreatorId, meetingAPI, user.Id]);

  if (loading) {
    return <h1>Loading....</h1>;
  }

  if (!isMeetingJoined)
    return (
      <button
        className="btn ml-1 mt-1 mr-1"
        onClick={startVideo}
      >
        Start Video
      </button>
    );
  else
    return (
      <button className="btn me-2 mt-2" onClick={endVideo}>
        End Video
      </button>
    );
};

export default StartVideo;
